import { GetServerSideProps, NextPage } from 'next';
import { __DEV__ } from 'utils/helpers';
import { SharedData, sharedDataQuery } from 'utils/queries';
import { getClient } from 'utils/sanity-server';

const StudioSpace: NextPage = () => {
  return null;
};

export default StudioSpace;

export const getServerSideProps: GetServerSideProps = async ({
  preview = __DEV__,
}) => {
  const sharedData = await getClient(preview).fetch<SharedData>(
    sharedDataQuery
  );

  // Redirect to the first studio space page
  const firstPageSlug = `/studio-space/${sharedData?.spaceInfoPaths[0].slug}`;

  return {
    redirect: {
      destination: firstPageSlug,
      permanent: false,
    },
  };
};
